import useGetPersistParams from "custom-hooks/useGetPersintParamas.hook";
import Link from "next/link";
import React from "react";
import { CPagesPath } from "shared/models/const/pages-path";
import useWindowSize from "custom-hooks/useWindowsSize.hook";
import { Avatar, Box, styled } from "@mui/material";

const CollectionCard = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "223px",
  position: "relative",
  display: "block",
  margin: "0 auto",
  paddingTop: "25px",
  "@media screen and (max-width: 400px)": {
    padding: "0 10px",
  },
}));

const CardLink = styled("a")({
  textDecoration: "none",
  "&:hover, &:active, &:visited": {
    textDecoration: "none",
  },
});

const CardLabel = styled("span")({
  position: "relative",
  left: "10px",
  backgroundColor: "white",
  color: "var(--color-text-black)",
  padding: "5px 10px",
  borderRadius: "10px 10px 0 0",
  letterSpacing: "1px",
  fontSize: ".9rem",
  fontWeight: 400,
  "@media screen and (max-width: 400px)": {
    bottom: "100%",
  },
});

const Thumbnail = styled(Box)({
  width: "100%",
  borderRadius: "15px",
  overflow: "hidden",
  height: "150px",
  position: "relative",
  zIndex: 10,
  backgroundColor: "#192c4f",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const ThumbnailImage = styled("img")({
  width: "100%",
  objectFit: "contain",
  objectPosition: "center",
});

const CardDescription = styled("span")({
  textAlign: "center",
  display: "inline-block",
  width: "100%",
  margin: "20px 0",
  fontSize: "1rem",
  fontWeight: 500,
  color: "var(--color-text-white)",
  city: {
    textTransform: "lowercase",
    "&:first-letter": {
      textTransform: "uppercase",
    },
  },
});

const CardDescriptionLight = styled("span")({
  color: "#fff",
  fontWeight: 400,
  // textTransform: "lowercase",
  // "&:first-letter": {
  //   textTransform: "uppercase !important",
  // },
});

function PropertyCollectionCard(props: any) {
  const ref = useGetPersistParams();
  const size = useWindowSize();
  const width: any = size?.width;

  return (
    <CollectionCard className={props.className}>
      <CardLink
        href={CPagesPath.es.collection_property_detail(props as any) + ref}
        className="collection__card_link"
        target={width > 991 ? "_blank" : ""}
        rel="nofollow noopener noreferrer"
      >
        <CardLabel>COLLECTION</CardLabel>
        <AvatarStyled
          variant="square"
          src={props?.main_picture?.big ?? "/icons/remax-balloon.png"}
          alt={`Collection Image-${props.id}-${props.sector}-${props.realstate_type}`}
        >
          {props.id}
        </AvatarStyled>

        <CardDescription>
          <span className="city">{props.realstate_type} </span>

          <CardDescriptionLight>
            {capitalizarFrase(props.sector)}
          </CardDescriptionLight>
        </CardDescription>
      </CardLink>
    </CollectionCard>
  );
}

export default PropertyCollectionCard;

const AvatarStyled = styled(Avatar)({
  width: "100%",
  height: "150px",
  borderRadius: "14px",
  overflow: "hidden",
  backgroundColor: "#192c4f",
});

function capitalizarFrase(frase: string) {
  if (typeof frase != "string") {
    return "";
  }
  const excepciones = [
    "la",
    "el",
    "los",
    "las",
    "de",
    "del",
    "en",
    "y",
    "a",
    "o",
    "con",
    "por",
    "para",
    "sin",
    "sobre",
    "al",
    "un",
    "una",
    "unos",
    "unas",
  ];

  return frase
    .toLowerCase()
    .split(" ")
    .map((palabra, index) => {
      if (index === 0 || !excepciones.includes(palabra)) {
        return palabra.charAt(0).toUpperCase() + palabra.slice(1);
      }
      return palabra;
    })
    .join(" ");
}

export interface IPropertyCollectionCard {
  picture: string;
  type: string;
  city: string;
  id: number;
  className?: string;
}
